import React from 'react';
import classNames from 'classnames';

import { makeStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles(theme => ({
  tabs: {
    width: '100%',
    borderRight: `1px solid ${theme.palette.divider}`,
    boxSizing: 'border-box'
  },
  tabPanel: {
    flex: 1
  }
}));

export function TabPanel(props) {
  const classes = useStyles();
  const { children, value, className, index, ...other } = props;

  return (
    <Typography
      component="div"
      className={classNames(classes.tabPanel, className)}
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && children}
    </Typography>
  );
}

export default ({ children, onChange, value, className }) => {
  const classes = useStyles();

  return (
    <Tabs
      indicatorColor="primary"
      orientation="vertical"
      value={value}
      onChange={onChange}
      aria-label="Vertical tabs example"
      className={classNames(classes.tabs, className)}
    >
      {children}
    </Tabs>
  );
};
